<!--
 * @Author:hjyec
 * @Date: 2021-08-20 11:11:10
 * @LastEditTime: 2023-04-26 16:34:56
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Description: In User Settings Edit
 * @FilePath: \鲁南\src\modules\fire\components\control.vue
-->
<template>
  <div
    class="ioc-alarm__list flex-valign fire-list"
    v-loading="dataLoading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    :class="{ closeList: isShowList }"
  >
    <controlTop
      ref="controlTop"
      @handleSearch="handleSearch"
      @handleType="handleType"
    ></controlTop>
    <div class="controlCenter">
      <span>
        未配置位置
        <el-checkbox
          :true-label="1"
          :false-label="0"
          v-model="searchForm.positionFlag"
          @change="serachList"
        ></el-checkbox>
      </span>
      <span>
        关联视频类型
        <el-select
          v-model="searchForm.relationCameraType"
          placeholder="请选择"
          @change="serachList"
          clearable
          style="width: 140px"
        >
          <el-option
            v-for="item in videoOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </span>
    </div>

    <div class="planSearch">
      <el-input
        style="width: 85%"
        placeholder="请输入搜索关键字"
        @clear="handleClear"
        v-model="searchForm.deviceName"
        @keyup.enter.native="serachList()"
        clearable
      >
      </el-input>
      <span> | </span>
      <img src="@src/common/assets/images/search.png" alt="" @click="serachList" />
    </div>
    <el-scrollbar
      ref="alarmList"
      class="ioc-alarm__scrollbar"
      style="padding: 10px 0; margin-top: 0px; height: 100%"
    >
      <div class="noData" v-if="data.length === 0 && !isShowList">
        <div class="text-center" style="margin-bottom: 10px">
          <img src="@/common/assets/images/empty.svg" class="no-data_img" />
        </div>
        {{ $t("realTimeAlarm.title.noData") }}
      </div>

      <ul class="item-container">
        <li
          class="map-blur-panel__list-item"
          style="height: 100%; cursor: pointer"
          :class="[checkItem.deviceId == item.deviceId ? 'active' : '']"
          v-for="(item, index) in data"
          :draggable="true"
          @dragstart="dragStart($event, item)"
          :key="index"
          @contextmenu.prevent="
            (e) => {
              !controlpageType && rightClick(item, e);
            }
          "
          @click.stop="!controlpageType && itemClick(item)"
        >
          <div
            v-if="visibleRightId == item.thirdDeviceId"
            class="rightTip"
            :style="{
              left: tipLeft + 'px',
              top: tipTop + 'px',
            }"
          >
            <el-button type="text" @click.stop="handleDevice(item)" title="设备操作">
              设备操作
            </el-button>
            <el-button @click.stop="handleLog(item)" title="运行数据" type="text"
              >运行数据</el-button
            >
            <el-button title="位置更改" type="text" @click.stop="handleUpdate(item)"
              >位置更改</el-button
            >
            <el-button title="信息修改" type="text" @click.stop="handleUpdateDevice(item)"
              >信息修改</el-button
            >
            <el-button title="关联视频" type="text" @click.stop="handleLinkVideo(item)"
              >关联视频</el-button
            >
            <el-button title="一键配置" type="text" @click.stop="handleConfig(item)"
              >一键配置</el-button
            >
            <span title="关闭" class="closeTitle" @click.stop="visibleRightId = ''">
              <i class="el-icon-circle-close"></i>
            </span>
          </div>
          <!-- 名称 -->
          <div
            class="alarm_name"
            :title="
              '【' +
              (!item.subDeviceMark
                ? item.parentThirdDeviceId + '】' + item.parentDeviceName
                : item.thirdDeviceId + '】' + item.deviceName)
            "
          >
            <span>
              【
              {{ item.subDeviceMark ? item.thirdDeviceId : item.parentThirdDeviceId }}
              】
            </span>
            <span>
              {{ item.subDeviceMark ? item.deviceName : item.parentDeviceName }}
            </span>
          </div>
          <!-- 图标 -->
          <div style="margin: 15px 0 5px; display: flex">
            <img
              :title="item.positionFlag == 1 ? '已配置位置' : '未配置位置'"
              style="width: 16px; height: 17px; margin-right: 15px"
              :src="
                item.positionFlag == 1
                  ? 'images/theme/newDark/map/resource/marker_primary.png'
                  : 'images/theme/newDark/map/resource/point.png'
              "
            />
            <i
              v-if="item.subDeviceMark"
              class="icon iconfont-lunan"
              :title="item.subDeviceMark | dic('SENU094')"
              :class="['icon-lunan-SENU094' + item.subDeviceMark]"
            ></i>
            <i
              v-if="!item.subDeviceMark"
              title="主机"
              class="icon iconfont-lunan"
              :class="['icon-lunan-SENU087' + item.deviceMark]"
            ></i>
            <!-- 摄像机 -->
            <i
              style="margin-left: 15px"
              :style="{
                color:
                  item.relationCameraType == 3
                    ? 'green'
                    : item.relationCameraType == 2
                    ? '#FFA500'
                    : '#1E90FF',
              }"
              title="摄像机"
              class="icon iconfont-lunan icon-lunan-shexiangjizuguanli"
            ></i>
          </div>
        </li>
      </ul>
    </el-scrollbar>
    <el-dialog
      title="运行数据"
      :visible.sync="linkDialog"
      append-to-body
      width="1020px"
      class="choose-box"
    >
      <ioc-table
        style="height: 400px"
        ref="crud"
        :data="workingData"
        :option="workingOptions"
        :page="workingPage"
        @search-change="handleSearchChange"
        @search-reset="handleSearchReset"
        @size-change="personChangeSize"
        @current-change="currentChange"
      >
      </ioc-table>
    </el-dialog>
    <!-- 设备详情 -->
    <el-dialog
      title="设备信息修改"
      :visible.sync="deviceDialog"
      append-to-body
      width="800px"
      class="choose-box"
    >
      <!-- 主机 -->
      <el-form
        v-if="updateState == 2"
        ref="deviceForm"
        :rules="deviceRule"
        :model="deviceForm"
        label-width="130px"
        style="display: flex; justify-content: space-between; flex-flow: wrap"
      >
        <el-col :span="11">
          <el-form-item label="消防主机编号" prop="thirdDeviceId">
            <el-input v-model="deviceForm.thirdDeviceId" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="消防主机名称" prop="deviceName">
            <el-input v-model="deviceForm.deviceName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="设备厂商" prop="factoryId">
            <el-select
              v-model="deviceForm.factoryId"
              style="width: 100%"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in factoryList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="消防型号" prop="deviceVersion">
            <el-select
              v-model="deviceForm.deviceVersion"
              style="width: 100%"
              clearable
              placeholder="请选择消防型号"
            >
              <el-option
                v-for="item in deviceVersionList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="设备类型" prop="deviceMark">
            <el-select
              disabled
              v-model="deviceForm.deviceMark"
              style="width: 100%"
              placeholder="请选择设备类型"
            >
              <el-option
                v-for="item in deviceMarkList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="11">
          <el-form-item label="IP地址" prop="deviceHost">
            <el-input v-model="deviceForm.deviceHost"></el-input>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="11">
          <el-form-item label="系统地址" prop="mac">
            <el-input v-model="deviceForm.mac"></el-input>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="11">
          <el-form-item label="类型标志" prop="typeMark">
            <el-input v-model="deviceForm.typeMark"></el-input>
          </el-form-item>
        </el-col> -->
        <el-col :span="11">
          <el-form-item label="设备状态" prop="status">
            <el-select
              v-model="deviceForm.status"
              style="width: 100%"
              clearable
              disabled
              placeholder="请选择状态"
            >
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="11">
          <el-form-item label="上传方式" prop="codeType">
            <el-select
              v-model="deviceForm.codeType"
              style="width: 100%"
              placeholder="请选择上传方式"
            >
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="24">
          <el-form-item label="控制模式" prop="controlMode">
            <el-select
              v-model="deviceForm.controlMode"
              style="width: 100%"
              placeholder="请选择控制模式"
            >
              <el-option
                v-for="item in controlList"
                :key="'c' + item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="isShow">
          <el-form-item label="控制器编号" prop="controlCodeList">
            <el-select
              v-model="deviceForm.controlCodeList"
              style="width: 100%"
              multiple
              placeholder="请选择控制器编号"
            >
              <el-option
                v-for="item in controlCodeOption"
                :key="'d' + item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <template v-if="isShowWater">
          <el-col :span="24">
            <el-form-item label="消防水位/m" prop="waterLevel">
              <el-input v-model="deviceForm.waterLevel"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="低水位范围/m" prop="lowWaterThreshold">
              <el-input
                v-model="deviceForm.lowWaterThreshold"
                placeholder="范围格式:0-100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="低低水位范围/m" prop="llowWaterThreshold">
              <el-input
                v-model="deviceForm.llowWaterThreshold"
                placeholder="范围格式:0-100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="高水位范围/m" prop="highWaterThreshold">
              <el-input
                v-model="deviceForm.highWaterThreshold"
                placeholder="范围格式:0-100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="高高水位范围/m" prop="hhighWaterThreshold">
              <el-input
                v-model="deviceForm.hhighWaterThreshold"
                placeholder="范围格式:0-100"
              ></el-input>
            </el-form-item>
          </el-col>
        </template>

        <el-col :span="24">
          <el-form-item label="备注说明" prop="thirdDeviceDesc">
            <el-input
              v-model="deviceForm.thirdDeviceDesc"
              type="textarea"
              placeholder="请输入备注说明"
              maxlength="255"
              show-word-limit
              :rows="3"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <!-- 部件 -->
      <el-form
        v-else
        ref="deviceForms"
        :rules="deviceRules"
        :model="deviceForms"
        label-width="100px"
        style="display: flex; justify-content: space-between; flex-flow: wrap"
      >
        <el-col :span="11">
          <el-form-item label="部件名称" prop="deviceName">
            <el-input v-model="deviceForms.deviceName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="部件类型" prop="subDeviceMark">
            <el-select
              v-model="deviceForms.subDeviceMark"
              style="width: 100%"
              clearable
              placeholder="请选择部件类型"
            >
              <el-option
                v-for="item in subDeviceMarkList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="部件地址" prop="mac">
            <el-input v-model="deviceForms.mac"></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="11">
          <el-form-item label="回路" prop="loop">
            <el-input v-model="deviceForms.loop"></el-input>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="11">
          <el-form-item label="二次码" prop="secondaryCode">
            <el-input v-model="deviceForms.secondaryCode"></el-input>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="11">
         <el-form-item label="控制器编号" prop="controlCode">
            <el-input v-model="deviceForms.controlCode"></el-input>
          </el-form-item>
        </el-col>  -->
        <el-col :span="24">
          <el-form-item label="部件说明" prop="thirdDeviceDesc">
            <el-input
              v-model="deviceForms.thirdDeviceDesc"
              type="textarea"
              placeholder="请输入部件说明"
              maxlength="255"
              show-word-limit
              :rows="3"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeForm" type="info"> 取消 </el-button>

        <el-button type="primary" @click="saveForm"> 确认 </el-button>
      </span>
    </el-dialog>
    <!-- <key-config-dialog
      ref="keyConfig"
      :deviceId="keyDeviceId"
      v-if="keyConfigShow"
    ></key-config-dialog> -->
  </div>
</template>
<script>
import { Dic } from "$utils";
import utils from "@src/common/utils";
import { api } from "../api";
import { workingOptions } from "../config/operation";
import ControlTop from "./controlTop.vue";
export default {
  name: "controlList",
  components: {
    ControlTop,
  },
  props: {
    data: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      deviceMarkList: [],
      linkVideoDialog: false,
      keyConfigShow: false,
      linkVideoForm: {
        thirdDeviceId: "", //主机编号
        parentDeviceName: "",
        deviceName: "", //部件名称
        subDeviceName: "", //部件名称
        subDeviceMark: "", //部件型号
        relationCameraType: "", //关联摄像机方式
      },
      linkVideoRule: {},
      deviceForm: {
        waterLevel: "",
        lowWaterThreshold: "",
        llowWaterThreshold: "",
        highWaterThreshold: "",
        hhighWaterThreshold: "",
        thirdDeviceDesc: "", //
        controlMode: "", //
        // codeType: "", //
        status: "", //
        typeMark: "", //
        // mac: "", //
        // deviceHost: "", //
        deviceVersion: "", //
        deviceName: "", //
        factoryId: "", //
        thirdDeviceId: "", //
        controlCodeList: [],
      },
      deviceForms: {
        thirdDeviceDesc: "",
        subDeviceMark: "", //
        mac: "", //
        // loop: "", //
        secondaryCode: "", //
        deviceName: "", //
        // controlCode: "", //
        deviceId: "", //
      },
      deviceRule: {
        // codeType: [{ required: true, message: "请输入", trigger: "change" }],
        status: [{ required: true, message: "请输入", trigger: "change" }],
        controlCodeList: [{ required: true, message: "请输入", trigger: "change" }],
        typeMark: [{ required: true, message: "请输入", trigger: "change" }],
        controlMode: [{ required: true, message: "请输入", trigger: "change" }],
        factoryId: [{ required: true, message: "请输入", trigger: "change" }],
        deviceVersion: [{ required: true, message: "请输入", trigger: "change" }],
        deviceName: [{ required: true, message: "请输入", trigger: "blur" }],
        // mac: [{ required: true, message: "请输入", trigger: "blur" }],
        // deviceHost: [{ required: true, message: "请输入", trigger: "blur" }],
        thirdDeviceDesc: [{ required: true, message: "请输入", trigger: "blur" }],
        waterLevel: [{ required: true, message: "请输入", trigger: "blur" }],
        lowWaterThreshold: [{ required: true, message: "请输入", trigger: "blur" }],
        llowWaterThreshold: [{ required: true, message: "请输入", trigger: "blur" }],
        highWaterThreshold: [{ required: true, message: "请输入", trigger: "blur" }],
        hhighWaterThreshold: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      deviceRules: {
        subDeviceMark: [{ required: true, message: "请输入", trigger: "change" }],
        deviceName: [{ required: true, message: "请输入", trigger: "change" }],
        mac: [{ required: true, message: "请输入", trigger: "blur" }],
        // loop: [{ required: true, message: "请输入", trigger: "blur" }],
        thirdDeviceDesc: [{ required: true, message: "请输入", trigger: "change" }],
      },
      deviceVersionList: Dic.find("SENU095"),
      subDeviceMarkList: Dic.find("SENU094"),
      factoryList: [],
      controlList: [
        { label: "单机模式", value: "0" },
        { label: "多分机模式", value: "1" },
      ],
      statusList: [
        { label: "在线", value: "1" },
        { label: "离线", value: "0" },
      ],
      // typeList: [
      //   { label: "回路部件", value: "0" },
      //   { label: "用户编码", value: "1" },
      // ],
      deviceDialog: false,
      searchForm: {
        positionFlag: "", //是否配置位置
        relationCameraType: "", //关联视频类型
        parentThirdDeviceId: "", //主机名称
        subDeviceMark: "", //部件类型
        deviceName: "",
      },
      videoOptions: [
        {
          value: 1,
          label: "关联主机视频",
        },
        {
          value: 2,
          label: "关联楼栋楼层视频",
        },
        {
          value: 3,
          label: "自定义配置",
        },
      ],
      tipLeft: "",
      tipTop: "",
      autoHeight: 110,
      dataLoading: false,
      isShowList: false,
      alarmList: "",
      boxScrollContainer: "",
      scrollView: "",
      visibleRightId: "",
      deviceId: "",
      keyDeviceId: "",
      linkDialog: false,
      workingOptions: workingOptions(),
      workingData: [],
      workingPage: {
        pageNum: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      rightClickItem: {},
      updatedDeviceInfo: {},
      alarmTypeList: [],
      treeData: [],
      updateState: "",
      controlCodeOption: Dic.find("SENU095001"),
      isShow: false,
      isShowWater: false,
      controlpageType: false,
      checkItem: {},
    };
  },
  created() {},
  mounted() {
    Dic.find("SENU087").map((item) => {
      if (
        item.value == "27" ||
        item.value == "28" ||
        item.value == "29" ||
        item.value == "35" ||
        item.value == "36" ||
        item.value == "37"
      ) {
        this.deviceMarkList.push(item);
      }
    });
    this.scrollbar();
    this.queryFactoryList();
  },

  methods: {
    handleClear() {
      this.$refs.controlTop.searchForm.name = "";
      this.$emit("handleSearchList", this.searchForm);
    },
    // 拖拽开始
    dragStart(e, data) {
      e.dataTransfer.setData("item", JSON.stringify(data));
    },
    // 配置/控制类型切换
    handleType(val) {
      this.controlpageType = val;
      this.$emit("handleType", val);
    },
    //一键配置
    handleConfig(data) {
      this.$emit("handleConfig", data);
      // this.keyConfigShow = true;
      // this.keyDeviceId = data.deviceId;
      // this.$nextTick(() => {
      //   this.$refs.keyConfig.dialogShow = true;
      // });
    },
    //关联视频修改
    handleLinkVideo(data) {
      //this.linkVideoDialog = true
      this.linkVideoForm = {
        parentThirdDeviceId: data.parentThirdDeviceId, //主机编号
        parentDeviceName: data.parentDeviceName, //主机名称
        deviceId: data.deviceId,
        deviceName: data.deviceName, //部件名称
        subDeviceMark: Number(data.subDeviceMark), //部件型号
        relationCameraType: Number(data.relationCameraType), //关联摄像机方式
      };
      this.$emit("rightVideoClick", this.linkVideoForm);
    },

    // 修改设备信息确认
    saveForm() {
      if (this.updateState == 1) {
        // 部件
        this.$refs["deviceForms"].validate((valid) => {
          if (valid) {
            let form = {
              deviceID: this.deviceForms.deviceId,
              factoryId: this.deviceForms.factoryId,
              subDeviceMark: this.deviceForms.subDeviceMark,
              mac: this.deviceForms.mac,
              // loop: this.deviceForms.loop,
              thirdDeviceName: this.deviceForms.deviceName,
              thirdDeviceDesc: this.deviceForms.thirdDeviceDesc,
              secondaryCode: this.deviceForms.secondaryCode,
              // controlCode: this.deviceForms.controlCode,
            };
            this.$fetch(api.cms.updateFireSubDevice, form).then((res) => {
              if (res && res.success) {
                this.deviceDialog = false;
                this.$message.success("修改成功");
                this.visibleRightId = "";
                this.$emit("updateDeviceInfo");
              } else {
                this.$message.error(res.msgContent || "设备数据修改失败");
              }
            });
          }
        });
      } else {
        // 主机
        this.$refs["deviceForm"].validate((valid) => {
          if (valid) {
            let params = {
              controlMode: this.deviceForm.controlMode, //
              deviceMark: this.deviceForm.deviceMark,
              // codeType: this.deviceForm.codeType,
              // mac: this.deviceForm.mac, //
              status: this.deviceForm.status, //
              typeMark: this.deviceForm.typeMark, //
              deviceVersion: this.deviceForm.deviceVersion, //
              deviceHost: this.deviceForm.deviceHost, //
              thirdDeviceId: this.deviceForm.thirdDeviceId, //
              deviceID: this.deviceForm.deviceId,
              factoryId: this.deviceForm.factoryId,
              thirdDeviceName: this.deviceForm.deviceName,
              thirdDeviceDesc: this.deviceForm.thirdDeviceDesc, //
              waterLevel: this.deviceForm.waterLevel, //
              lowWaterThreshold: this.deviceForm.lowWaterThreshold, //
              llowWaterThreshold: this.deviceForm.llowWaterThreshold, //
              highWaterThreshold: this.deviceForm.highWaterThreshold, //
              hhighWaterThreshold: this.deviceForm.hhighWaterThreshold, //
            };
            if (
              this.deviceForm.controlMode == "1" &&
              (this.deviceForm.deviceMark == 29 || this.deviceForm.deviceMark == 28)
            ) {
              params.controlCodeList = this.deviceForm.controlCodeList;
            }
            this.$fetch(api.cms.updateFireDevice, params).then((res) => {
              if (res.success) {
                this.deviceDialog = false;
                this.$message.success("修改成功");
                this.visibleRightId = "";
                this.$emit("updateDeviceInfo");
              } else {
                this.$message.error(res.msgContent || "设备数据修改失败");
              }
            });
          }
        });
      }
    },
    closeForm() {
      this.deviceDialog = false;
      // this.deviceForm = {};
      this.$refs.deviceForm && this.$refs.deviceForm.resetFields();
      this.$refs.deviceForms && this.$refs.deviceForms.resetFields();
      // this.deviceForms = {};
    },
    queryFactoryList() {
      this.$fetch(api.device.queryFactoryList).then((res) => {
        if (res.success) {
          this.factoryList = res.returnObj.map((item) => {
            return {
              label: item.factoryName,
              value: item.factoryId,
            };
          });
          // console.log(this.factoryList);
        }
      });
    },

    //运行数据下拉框搜索
    handleSearchChange(param) {
      // console.log(param);
      this.alarmTypeList = param.statusDesc && [param.statusDesc];
      this.getWorkingData();
    },
    // 重置列表
    handleSearchReset() {
      this.alarmTypeList = [];
      this.getWorkingData();
    },
    personChangeSize(val) {
      this.workingPage.pageNum = 1;
      this.workingPage.pageSize = val;
      this.getWorkingData();
    },
    currentChange(val) {
      this.workingPage.pageNum = val;
      this.getWorkingData();
    },
    // 设备操作
    handleDevice(item) {
      let newMsg = window.location.href.split("#")[0];
      window.open(newMsg + "#/fireManage?id=" + item.deviceId);
      // this.$router.push({
      //   path: "/fireManage",
      //   name: "fireManage",
      //   query: {
      //     id: item.deviceId,
      //   },
      // });
    },
    // 操作日志
    handleLog(item) {
      this.linkDialog = true;
      this.rightClickItem = item;
      this.alarmTypeList = [];
      this.workingPage.pageNum = 1;
      this.workingPage.pageSize = 10;
      this.getWorkingData();
    },
    closeDevicePlace() {
      this.visibleRightId = "";
      this.updatedDeviceInfo = {};
    },
    // 位置更改
    handleUpdate(item, type = 1) {
      this.updatedDeviceInfo = {};
      Object.assign(this.updatedDeviceInfo, item);
      this.$emit("handleUpdate", item, type);
    },
    controlModeChange(data) {
      // if (
      //   (this.deviceForm.deviceMark == 28 || this.deviceForm.deviceMark == 29) &&
      //   data == "1"
      // ) {
      //   this.isShow = true;
      // } else {
      //   this.isShow = false;
      // }
    },
    // 信息修改
    handleUpdateDevice(item) {
      // console.log(item);
      this.deviceDialog = true;
      if (item.subDeviceMark) {
        // 部件
        this.updateState = "1";
        this.deviceForm = {};
        this.deviceForms = {
          subDeviceMark: Number(item.subDeviceMark), //
          mac: item.mac, //
          // loop: item.loop, //
          // secondaryCode: item.secondaryCode, //
          deviceName: item.deviceName, //
          factoryId: item.factoryId, //
          // controlCode: item.controlCode, //
          deviceId: item.deviceId, //
          thirdDeviceDesc: item.thirdDeviceDesc, //
        };
      } else {
        // 主机
        // if (
        //   item.controlMode === "1" &&
        //   (item.deviceMark == 28 || item.deviceMark == 29)
        // ) {
        //   this.isShow = true;
        // } else {
        //   this.isShow = false;
        // }
        if (item.deviceMark == 36 || item.deviceMark == 37) {
          this.isShowWater = true;
        } else {
          this.isShowWater = false;
        }

        this.updateState = "2";
        this.deviceForms = {};
        this.deviceForm = {
          thirdDeviceDesc: item.parentThirdDeviceDesc, //
          controlMode: item.controlMode, //
          // codeType: item.codeType,
          deviceVersion: Number(item.deviceVersion),
          // mac: item.parentMac, //
          status: item.status, //
          typeMark: item.typeMark, //
          deviceHost: item.ip, //
          deviceMark: Number(item.deviceMark), //
          factoryId: item.factoryId, //
          factoryName: item.factoryName, //
          deviceName: item.parentDeviceName, //
          thirdDeviceId: item.parentThirdDeviceId, //
          deviceId: item.deviceId, //
          controlCodeList: [],
          waterLevel: item.waterLevel, //
          lowWaterThreshold: item.lowWaterThreshold, //
          llowWaterThreshold: item.llowWaterThreshold, //
          highWaterThreshold: item.highWaterThreshold, //
          hhighWaterThreshold: item.hhighWaterThreshold, //
        };
        if (item.controlCode) {
          let arr = item.controlCode.split(",");
          arr.forEach((items) => {
            this.deviceForm.controlCodeList.push(Number(items));
          });
        }
        // Object.assign(this.deviceForm, item);
      }
      // this.$emit("handleUpdateDevice", item);
    },
    // 获取运行数据列表
    getWorkingData() {
      let params = {
        deviceId: this.rightClickItem.deviceId,
        pageNum: this.workingPage.pageNum,
        pageSize: this.workingPage.pageSize,
        alarmTypeList: this.alarmTypeList,
      };
      this.$fetch(api.alarm.getWorkingList, params).then((response) => {
        if (response.success) {
          this.workingData = response.returnObj.list;
          this.workingPage.total = response.returnObj ? response.returnObj.total : 0;
        } else {
          this.$message.error(response.msgContent || "获取运行数据失败");
        }
      });
    },
    // controlTop搜索回调
    handleSearch(val) {
      // this.searchForm.parentThirdDeviceId = val.parentThirdDeviceId || "";
      this.searchForm.deviceName = val.parentThirdDeviceId || "";
      this.searchForm.subDeviceMark = val.subDeviceMark || "";
      this.serachList();
    },
    // control 搜索
    serachList() {
      this.$emit("handleSearchList", this.searchForm);
    },
    rightClick(val, e) {
      this.$emit("leftClickItem", val);
      this.tipLeft = e.pageX > 300 ? 200 : e.offsetX;
      this.tipTop = e.offsetY + 15;
      this.visibleRightId = val.thirdDeviceId;
      val.isExpand = false;
      this.checkItem = { ...val };
    },
    itemClick(item) {
      this.visibleRightId = "";
      this.checkItem = { ...item };
      this.$emit("leftClickItem", item);
    },
    // 翻页-下拉刷新
    scrollbar() {
      this.alarmList = this.$refs.alarmList;
      this.boxScrollContainer = this.alarmList.$el.querySelector(".el-scrollbar__wrap");
      this.scrollView = this.boxScrollContainer.querySelector(".el-scrollbar__view");

      this.scrollFun = (e) => {
        if (
          e.srcElement.scrollTop + this.boxScrollContainer.clientHeight >=
            this.scrollView.clientHeight &&
          !this.dataLoading &&
          this.data.length % 30 === 0 &&
          this.data.length !== 0
        ) {
          this.$emit("nextPage");
        }
      };
      this.boxScrollContainer.addEventListener("scroll", this.scrollFun);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.planSearch {
  // background: #202631;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // margin: 10px;
  padding: 0px 10px 10px;
  :deep .el-input__inner {
    border: none !important;
    // height: 40px;
  }
  span {
    height: 20px;
  }
  img {
    // width: 16px;
    // height: 16px;
    cursor: pointer;
  }
}
.controlCenter {
  // background: #202631;
  @include set_theme_color(background-color, page-default-color);
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 5px 10px;
  color: #fff;
}
.item-container li:first-child {
  margin-top: 0;
}

.item-container li {
  height: 100%;
  // padding: 10px;
  margin-top: 10px;
  position: relative;
  width: 100%;
  height: 82px;
  padding: 15px 20px 12px 20px;
  opacity: 1;
  border-radius: 10px;
  .alarm_name {
    font-size: 16px;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.ioc-alarm__list {
  height: calc(100% - 20px) !important;
}
.icon-transform {
  transform: rotate(180deg);
}
.list-detail {
  // position: absolute;
  // height: 200px;
  width: 100%;
  // left: 0;
  font-size: 14px;
  @include set_theme_color(background-color, page-bg-color);
  padding: 10px 4px;
  z-index: 2;
  .listTitle {
    height: 24px;
    line-height: 24px;
    margin: px 0;
    display: flex;
    margin-bottom: 10px;
    flex-direction: row;
    justify-content: space-between;
    color: #fff;
    button {
      padding: 7px 5px;
    }
  }
  .listUl {
    // height: 120px;
    // overflow: hidden;
    .listLi {
      position: relative;
      width: 100%;
      padding: 0px;
      margin-bottom: 0px;
      height: 28px;
      line-height: 28px;
      margin: 5px 0;
      color: #fff !important;
      // @include set_theme_color(background-color, dialog-content-bg-color);
      &:hover {
        @include set_theme_color(background-color, main-theme-color);
      }
      .listLi_time {
        font-size: 12px;
        height: 20px;
      }
      .listLi_level {
        width: 50px;
        height: 24px;
        padding-top: 0px;
        text-align: center;
        border-radius: 4px;
        position: absolute;
        margin: 2px 0;
        // right: 27px;
      }
      &:hover {
        opacity: 0.8;
      }
    }
  }
  .listbt {
    text-align: center;
    margin-top: 5px;
  }
}
.rightTip {
  // border: 1px solid rgb(218, 220, 224);
  position: absolute;
  top: 33px;
  // height: 55%;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40%;
  padding: 6px 3px;
  text-align: center;
  border-radius: 4px;
  color: #fff !important;
  background-color: #407aee;

  button {
    flex: 1;
    width: 100%;
    border: none;
    margin-left: 0;
    margin: 5px 0;
    &:hover {
      opacity: 0.8;
      // @include set_theme_color(color, main-theme-color);
    }
  }
  .closeTitle {
    // color: red;
    font-size: 18px;
    color: #fff !important;
    position: absolute;
    right: 5px;
    top: 5px;
  }
}
.ioc-alarm__list__title {
  background-color: rgba(0, 0, 0, 0.5);
}
.noData {
  text-align: center;
  height: 80px;
}
</style>
